const priceTables = document.querySelectorAll(".js-price-and-date-table-wrapper table");
const expandableRowHandlers = document.querySelectorAll(".expandable-travel-dates > tbody > tr:not(.expanded-content)");
var expandablePriceTables = {
    init: function () {
        if (priceTables) {

            for (let table of priceTables) {
                let headerRowIndex = table.classList.length > 0 ? 0 : 1;
                const tableHeaders = table.rows[headerRowIndex].children;
                [...table.rows].forEach((tableRow, index) => {
                    if (index > headerRowIndex) {
                        tableRow.querySelectorAll(":scope > td").forEach(el => 
                            el.dataset.th = tableHeaders[Array.prototype.indexOf.call(tableRow.children, el)].innerHTML.replace(/<[^>]*>?/gm, ''));
                    }
                });
                
                const expandableContentCells = table.querySelectorAll(".expanded-content > td");
                var spanCount = table.rows[0].children.length;
                if (expandableContentCells) {
                    expandableContentCells.forEach(el => el.colSpan = spanCount);
                }
            }
    
            if (expandableRowHandlers)
                expandableRowHandlers.forEach(el => el.addEventListener("click", this.expandRow));
        }
    },
    expandRow: function () {
        let isActive = this.classList.contains("active");
        const expandableRows = document.querySelectorAll(".expanded-content");
        expandableRows.forEach(el => el.style.removeProperty("display"));
        expandableRowHandlers.forEach(el => el.classList.remove("active"))
        if (!isActive) {
            this.nextElementSibling.style.display = "table-row";
            this.classList.add("active");
        }
    }

}

export default expandablePriceTables;